// status-message.jsx
import "./status-message.css";
import { useTranslation } from "react-i18next";

type Properties = {
    isRecording: boolean;
};

export default function StatusMessage({ isRecording }: Properties) {
    const { t } = useTranslation();
    if (!isRecording) {
        return <p className="status-message mt-4 text-center text-gray-600">{t("status.notRecordingMessage")}</p>;
    }

    return (
        <div className="status-message mt-4 flex items-center">
            <div className="visualizer relative h-8 w-8 overflow-hidden">
                <div className="absolute inset-0 flex items-end justify-around">
                    {[...Array(4)].map((_, i) => (
                        <div
                            key={i}
                            className="bar btn-bg w-2 rounded-full opacity-90"
                            style={{
                                animation: `barAnimation${(i % 3) + 1} 1.2s ease-in-out infinite`,
                                animationDelay: `${i * 0.15}s`
                            }}
                        />
                    ))}
                </div>
            </div>
            <p className="ml-3 text-lg text-gray-700">{t("status.conversationInProgress")}</p>
        </div>
    );
}
